import { VegasCard, SectionHeader } from 'components/VegasConference';

const SectionCard = ({ title, subtitle, icon, children }) => {
  return (
    <VegasCard>
      <SectionHeader icon={icon} title={title} subtitle={subtitle} />
      {children}
    </VegasCard>
  );
};

export default SectionCard;
